import React from "react";
import Swal from "sweetalert2";

const ConfirmBox = (
  title,
  text,
  confirmTitle,
  cancelTitle,
  onClickConfirm,
  onClickCancel
) => {
  Swal.fire({
    title,
    text,
    icon: "warning",
    showCancelButton: true,
    allowOutsideClick: false,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: confirmTitle,
    cancelButtonText: cancelTitle,
  }).then((result) => {
    if (result.isConfirmed) {
      onClickConfirm();
    } else {
      onClickCancel();
    }
  });
};

export default ConfirmBox;
